import { createSlice, createSelector } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
// import axios from "axios";

const initialState = {
    entities: {
        showArchivedParticipants:false,
        GroupGuid: null,
        IsAdmin:false, 
        IsProxy:false, 
        LanguageName:"",
        LanguageId:-1,
        UnitOfMeasure:"",
        UnitOfMeasureId:"276018",
    },
    status: 'idle', // idle loading success fail  
    error: null
}



const contextSlice = createSlice({
    name: 'contexts',
    initialState,
    reducers: {        
        contextClear(state, action) {
            state.entities = initialState
            state.status = "idle"            
        },
 
        contextModifyOrgSettings(state, action) {
            const  {DataSetRealm, DataSetClass, DataSetFamily, DataSetType, ...keepThese} = state.entities
            state.entities=keepThese
        },
        contextUpsert(state, action) {
            const data = action.payload
            state.entities[data.Key] = data.Value
        }
 
    },
    
})

export const { contextClear,contextUpsert, } = contextSlice.actions

export default contextSlice.reducer

export const selectContextEntities = (state) => state.contexts.entities

export const selectContexts = createSelector(selectContextEntities, (entities) =>
    Object.values(entities)
)

export const selectContextById = (state, ContextId) => {
    return selectContextEntities(state)[ContextId]
}

